import { DocumentSnapshot, QuerySnapshot } from 'firebase/firestore'

import { DocumentDoesNotExistError } from 'utils/error/DocumentDoesNotExistError'

export const formatQuerySnapshot = (querySnapshot: {
  empty: QuerySnapshot['empty']
  forEach: QuerySnapshot['forEach']
}) => {
  if (querySnapshot.empty) {
    return []
  }
  const docs: any[] = []
  querySnapshot.forEach((doc) => {
    docs.push({
      ...doc.data(),
      id: doc.id,
    })
  })
  return docs
}

export const formatDocSnapshot = <T extends Record<string, unknown>>(
  docSnapshot?: DocumentSnapshot,
): T => {
  if (!docSnapshot?.exists()) throw new DocumentDoesNotExistError('Document does not exist')

  return { ...(docSnapshot.data() as T), id: docSnapshot.id }
}
